let beforeDate = () => {
  return {
      restrict: 'A',
      require: 'ngModel',
      link: (scope, element, attrs, ngModelController) => {
        ngModelController.$validators.beforeDate = function(modelValue, viewValue) {
          if (ngModelController.$isEmpty(modelValue) === true) {
              return true;
          }

          let value = moment(modelValue).startOf('day');

          if (!attrs.sbBeforeDate) {
            return true;
          }

          let endDate = attrs.sbBeforeDate.replace(/\"/g, '');

          endDate = moment(endDate).startOf('day');

          return value.isSameOrBefore(endDate);
        }
      }
  };
};

beforeDate.$inject = [];

export default beforeDate;



// WEBPACK FOOTER //
// ./client/app/common/field-validators/before-date.js